__turbopack_context__.v({
  "arrange": "content-head-module__CmqUhW__arrange",
  "arrangeFold": "content-head-module__CmqUhW__arrangeFold",
  "arrangeSheet": "content-head-module__CmqUhW__arrangeSheet",
  "filter": "content-head-module__CmqUhW__filter",
  "head": "content-head-module__CmqUhW__head",
  "meta": "content-head-module__CmqUhW__meta",
  "primary": "content-head-module__CmqUhW__primary",
});
